import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

/**
 * Filter bar for Most active users. Purely presentational — the container owns
 * all state and the registration-driven date auto-fill logic.
 *
 * Props:
 *   registrationFilter, platformFilter, activeDaysFilter, searchQuery,
 *   displayFrom, displayTo, showClear,
 *   onRegistrationChange, onPlatformChange, onActiveDaysChange, onSearchChange,
 *   onFromChange, onToChange, onSearch, onClear
 */
const MostActiveFilters = ({
  registrationFilter, platformFilter, activeDaysFilter, searchQuery,
  displayFrom, displayTo, showClear,
  onRegistrationChange, onPlatformChange, onActiveDaysChange, onSearchChange,
  onFromChange, onToChange, onSearch, onClear,
}) => (
  <div className="au-filters" data-testid="au-mau-filters">
    <div className="au-field">
      <label className="au-field__label" htmlFor="registration-filter">Registration</label>
      <select id="registration-filter" className="au-select" value={registrationFilter}
        onChange={(e) => onRegistrationChange(e.target.value)}>
        <option value="active">Active Date</option>
        <option value="0-30">Registered in last 30 days</option>
        <option value="31-90">Registered in last 31-90 days</option>
        <option value="91-120">Registered in last 91-120 days</option>
        <option value="120+">Registered 120+ days ago</option>
      </select>
    </div>

    <div className="au-field">
      <label className="au-field__label" htmlFor="platform-filter">Platform</label>
      <select id="platform-filter" className="au-select" value={platformFilter}
        onChange={(e) => onPlatformChange(e.target.value)}>
        <option value="">All</option>
        <option value="Android">Android</option>
        <option value="iOS">iOS</option>
      </select>
    </div>

    <div className="au-field">
      <label className="au-field__label" htmlFor="active-days-filter">Number of Active Days</label>
      <select id="active-days-filter" className="au-select" value={activeDaysFilter}
        onChange={(e) => onActiveDaysChange(e.target.value)}>
        <option value="">All</option>
        <option value="5-10">5-10</option>
        <option value="11-15">11-15</option>
        <option value="16-20">16-20</option>
        <option value="21-30">21-30</option>
        <option value="31+">31+</option>
      </select>
    </div>

    <div className="au-field">
      <label className="au-field__label">From active days</label>
      <DatePicker selected={displayFrom} onChange={onFromChange} dateFormat="dd/MM/yyyy" placeholderText="dd/mm/yyyy" className="au-date-input" />
    </div>

    <div className="au-field">
      <label className="au-field__label">To active days</label>
      <DatePicker selected={displayTo} onChange={onToChange} dateFormat="dd/MM/yyyy" placeholderText="dd/mm/yyyy" className="au-date-input" />
    </div>

    <div className="au-field">
      <label className="au-field__label" htmlFor="search-filter">Search</label>
      <input id="search-filter" className="au-input" type="text" placeholder="Name, email"
        value={searchQuery} onChange={(e) => onSearchChange(e.target.value)} />
    </div>

    <div className="au-field au-field--actions">
      <button type="button" className="au-btn au-btn--primary" onClick={onSearch}>Search</button>
      {showClear && <button type="button" className="au-btn au-btn--ghost" onClick={onClear}>Clear</button>}
    </div>
  </div>
);

export default MostActiveFilters;
